// extracted by mini-css-extract-plugin
export default {"append":"append_append__+YibX","heading":"append_heading__c5Q2Z","link":"append_link__NJbhg"};